export default __webpack_public_path__ + "static/media/menu.a9b53758.svg";